<div class='change-phone-modal'>
	<h2 class='modal-title' i18n>Update your phone number</h2>
	<form [formGroup]='phoneForm' (ngSubmit)='save()'>
		<div class='form-control with-flags'>
			<mat-form-field #phoneField class='phone-number-field'>
				<mat-label i18n='@@labelPhoneNumber'>Phone number</mat-label>

				<input type='hidden' formControlName='phoneNumberComplete'/>

				<div matPrefix
				     class='icon-prefix-padding phone-number-flags'>
					<input type='text' id='intl-tel-input-modal' #intlInputEl/>
				</div>

				<input matInput
				       formControlName='phoneNumber'
				       name='phoneNumber'
				       class='user-data-phone'
				       (blur)='verifyPhoneNumber()'
				       (input)='onPhoneNumberInput( $event )'
				       placeholder=''
				       type='tel'/>
			</mat-form-field>
			<mat-error *ngIf='phoneForm.get("phoneNumber")?.hasError("invalidPhoneNumber")' i18n='@@invalidPhoneNumber'>
				Your phone number appears to be invalid.
			</mat-error>
		</div>
		<p class='save-error' *ngIf='saveError'>{{ saveError }}</p>
		<div class='modal-actions'>
			<button class='btn-save' type='submit' [disabled]='!resubmitAllowed'>
				<ng-container *ngIf='!saveLoading && resubmitCooldownRemaining === 0' i18n>Save</ng-container>
				<ng-container *ngIf='saveLoading' i18n>Saving…</ng-container>
				<ng-container *ngIf='!saveLoading && resubmitCooldownRemaining > 0'>
					<span i18n>Save in ({{ resubmitCooldownRemaining }}s)</span>
				</ng-container>
			</button>
			<button class='btn-cancel' type='button' (click)='cancel()' [disabled]='saveLoading' i18n>Cancel</button>
		</div>
	</form>
</div>
